const isNumeric = n => {
  return !isNaN(parseFloat(n)) && isFinite(n)
}

export const deepEqual = (a1, b1, doCompareNumeric = false) => {
  const compare = (a, b, compareNumeric) => {
    if (depth++ > 200) {
      throw new Error('recursion too deep in deepEqual.js')
    }
    if (a === undefined) {
      return b === undefined
    } else if (b === undefined) {
      return false
    } else if (a === null) {
      return b === null
    } else if (b === null) {
      return false
    } else if (typeof a === 'object' && typeof b === 'object') {
      if (a === b) {
        return true
      } else {
        if (Object.keys(a).length !== Object.keys(b).length) {
          return false
        } else {
          return Object.keys(a).every(aKey => {
            const res = compare(a[aKey], b[aKey], compareNumeric)
            depth--
            return res
          })
        }
      }
    } else {
      if (compareNumeric && isNumeric(a) && isNumeric(b)) {
        return parseFloat(a) === parseFloat(b)
      }
      if (typeof a === 'function' && typeof b === 'function') {
        return a.toString() === b.toString()
      }
      return a === b
    }
  }

  let depth = 0
  const ret = compare(a1, b1, doCompareNumeric)
  return ret
}

export const newInstance = a => {
  if (a === null) {
    return null
  } else if (a === undefined) {
    return undefined
  } else if (typeof a === 'object') {
    const b = Object.prototype.toString.call(a) === '[object Array]' ? [] : {}
    Object.keys(a).forEach(aKey => {
      const tmp = newInstance(a[aKey])
      if (tmp !== undefined) {
        b[aKey] = tmp
      }
    })
    return b
  } else {
    return a
  }
}

export const deepCopy = newInstance
